import React from "react";
;
export var Skeleton = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 'auto' : _b, _c = _a.height, height = _c === void 0 ? 5 : _c, _d = _a.variant, variant = _d === void 0 ? 'square' : _d;
    var calculatedWidth = isNaN(width) ? width : width + 'px';
    var calculatedHeight = isNaN(height) ? height : height + 'px';
    return (React.createElement("div", { className: "skeleton", style: {
            width: calculatedWidth,
            height: calculatedHeight,
            borderRadius: variant === 'circle' ? calculatedWidth : '0px'
        } }));
};
